import { render, staticRenderFns } from "./batchImportInStock.vue?vue&type=template&id=0949a990&scoped=true"
import script from "./batchImportInStock.vue?vue&type=script&lang=js"
export * from "./batchImportInStock.vue?vue&type=script&lang=js"
import style0 from "./batchImportInStock.vue?vue&type=style&index=0&id=0949a990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0949a990",
  null
  
)

export default component.exports